import { render, staticRenderFns } from "./ExtendOtherNutrientsSelenium.vue?vue&type=template&id=4d2e620b&scoped=true"
import script from "./ExtendOtherNutrientsSelenium.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsSelenium.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsSelenium.vue?vue&type=style&index=0&id=4d2e620b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2e620b",
  null
  
)

export default component.exports